import { useNavigate } from 'react-router-dom';
import { Microscope, MonitorPlay } from 'lucide-react';
import { UniversalSmartLogin } from '../universal-smart-login';
import { aqlVisionApiUrl, publicAnonKey } from '@/utils/supabase/info';
import { useGlobal } from '@/app/providers/global-provider';

export function ConfigurationEntry() {
  const navigate = useNavigate();
  const { client } = useGlobal();

  return (
    <>
      <UniversalSmartLogin
        apiUrl={aqlVisionApiUrl}
        publicAnonKey={publicAnonKey}
        appName="AQL Vision"
        appId="vision-alerts"
        appIcon={<Microscope className="h-6 w-6" strokeWidth={1.5} />}
        appGradient="from-cyan-500 to-blue-600"
        requireClientSelection={true}
        onLoginSuccess={(token, email) => {
          localStorage.setItem('visionAlertsToken', token);
          localStorage.setItem('visionAlertsEmail', email);
          if (client?.slug) {
            navigate(`/${client.slug}`);
          } else {
            // Fallback if client isn't resolved yet
            navigate('/');
          }
        }}
      />

      <button
        type="button"
        onClick={() => navigate('/demo')}
        className="fixed bottom-5 right-5 z-50 inline-flex items-center gap-2 rounded-full border border-cyan-200/18 bg-slate-950/38 px-3.5 py-2 text-xs font-semibold text-cyan-50/78 shadow-lg shadow-slate-950/20 backdrop-blur-md transition-colors hover:border-cyan-200/34 hover:bg-slate-900/64 hover:text-cyan-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-cyan-300/50 dark:border-cyan-200/16 dark:bg-slate-950/42"
        aria-label="Abrir modo demo AQL Vision"
      >
        <MonitorPlay className="h-4 w-4" strokeWidth={1.7} />
        <span>Modo demo</span>
      </button>
    </>
  );
}
